// @flow
import classnames from 'classnames';
import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  button: {
    borderRadius: 100,
    boxShadow: '0px 4px 4px rgba(112, 144, 176, 0.25)',
    '&:hover': {
      backgroundColor: theme.palette.ava.navy5,
    },
  },
  centered: {
    justifyContent: 'center',
  },
  blue: {
    backgroundColor: theme.palette.ava.blue2,
    color: theme.palette.ava.white,
    '&:hover': {
      backgroundColor: theme.palette.ava.blue1,
    },
  },
  white: {
    backgroundColor: theme.palette.type === 'light' ? theme.palette.ava.white : theme.palette.ava.dark4,
    color: theme.palette.ava.blue2,
    border: `1px solid ${theme.palette.type === 'light' ? theme.palette.ava.navy5 : theme.palette.ava.dark5}`,
    boxShadow:
      theme.palette.type === 'light'
        ? '0px 4px 4px rgba(112, 144, 176, 0.25)'
        : '-3.65px -3.65px 10.96px rgba(49, 49, 49, 0.5), 3.65px 3.65px 10.96px #000000',
    '&:hover': {
      backgroundColor: theme.palette.type === 'light' ? theme.palette.ava.navy5 : theme.palette.ava.dark5,
    },
  },
  flat: {
    boxShadow: 'unset',
  },
}));

// $FlowFixMe
interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: Object;
  className?: string;
  buttonClasses?: Object;
  color?: string;
  centered?: boolean;
  flat?: boolean;
}

const RoundedButton = ({ children, className, buttonClasses, color, centered, flat, ...otherProps }: Props) => {
  const classes = useStyles();

  return (
    <Button
      className={classnames(classes.button, className, { [classes[color]]: color, [classes.flat]: flat })}
      classes={{ label: centered ? classes.centered : 'initial', ...buttonClasses }}
      {...otherProps}
    >
      {children}
    </Button>
  );
};

export default RoundedButton;
